var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGlobe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 108 8 8.01 8.01 0 00-8-8zm6.502 7.273h-2.888c-.03-1.848-.44-3.67-1.205-5.353a6.555 6.555 0 014.093 5.353zM8 14.546c-.835 0-2.023-2.243-2.167-5.819h4.334c-.145 3.575-1.332 5.819-2.167 5.819zM5.833 7.273C5.978 3.697 7.165 1.455 8 1.455c.835 0 2.022 2.242 2.167 5.818H5.833zM5.59 1.92a13.455 13.455 0 00-1.205 5.353H1.497A6.556 6.556 0 015.59 1.92zM1.497 8.727h2.888c.03 1.848.44 3.67 1.205 5.353a6.555 6.555 0 01-4.093-5.353zm8.912 5.353a13.453 13.453 0 001.205-5.353h2.888a6.555 6.555 0 01-4.093 5.353z",
    fill: "#001B28"
  })));
}

export default SvgGlobe;